<!-- 查询车场支付记录接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure";

  export default {
    name: "",
    components: {
      "right-structure": structure
    },
    props: ["commonUrls"],
    data() {
      return {
        requestBody: {
          "parkCode": "PTD2YBBZ",
          "payTime": "20240909"
        }
        ,
        responseCode: {
          "data":  {
            "fileName": "paymentRecordDetail_76AGDDSDD_20241202.zip",
            "msg": "10秒内有效",
            "url": "https://open-dev.yidianting.xin/v3/openydt/files/download/paymentRecordDetail_123123_20241202.zip?key=c5f7645122389f467d6cffdb2e8d08&coopKey=ake"
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取车场支付账单文件",
          t_url: this.commonUrls.test + "getPaymentRecordDetailFile",
          p_url: this.commonUrls.prod + "getPaymentRecordDetailFile",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "parkCode",
                  info2: "是",
                  info3: "String",
                  info4: "停车场编号"
                },
                {
                  info1: "payTime",
                  info2: "是",
                  info3: "String",
                  info4: "账单时间， yyyyMMdd"
                }
              ]
            }
          ],
          R_params: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "fileName",
                  info2: "是",
                  info3: "String",
                  info4: "文件名"
                },
                {
                  info1: "url",
                  info2: "下载url",
                  info3: "string",
                  info4: "当前获取的记录数"
                },
                {
                  info1: "msg",
                  info2: "是",
                  info3: "String",
                  info4: "提示"
                },
                {
                  info1: "",
                  info2: "",
                  info3: "注意",
                  info4: "下载的文件是zip格式，解压得到账单txt文件 <br>"  +
                    "txt文件每行都是json字符串<br>" +
                    "第一行是车场账单金额汇总和数据总条数 数据<br>" +
                    "其余行数与接口：查询车场支付账单详情 <br>" +
                    "回参中recordList数据一致"
                }
              ]
            }
          ],
          codeStatus: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "状态码", tdName: "info1"},
                {tableHead: "说明", tdName: "info2"}
              ],
              td: [
                {info1: "000110", info2: "失败"},
                {info1: "00110000", info2: "失败"},
                {info1: "110000", info2: "失败"}
              ]
            }
          ]
        }
      };
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getPaymentRecordDetailFile.vue